import axios from 'axios'
import router from '../router'
import store from '../commons/store/index'
import _ from 'lodash';
import {exceptions, mutationTypes, notificacoesDefault} from '../commons/constants/index'

const requestSuccessInterceptor = config => {
    store.commit(mutationTypes.LOKI.SET_GLOBAL_LOADING, true)
    return config
}

const responseSuccessInterceptor = response => {
    store.commit(mutationTypes.LOKI.SET_GLOBAL_LOADING, false)
    store.commit(mutationTypes.LOKI.SET_LOADING_MESSAGE, store.state.defaultLoadingMessage)
    return response
}

const errorHandlerInterceptor = error => {
    store.commit(mutationTypes.LOKI.SET_GLOBAL_LOADING, false)
    store.commit(mutationTypes.LOKI.SET_LOADING_MESSAGE, store.state.defaultLoadingMessage)

    if (!possuiConexaoComInternet(error)) {
        handlerErroSemConexaoInternet()
    } else if (error.response.status === 500) {
        handlerErro500(error)
    } else if (error.response.status === 400) {
        handlerErro400(error)
    } else if (error.response.status === 401) {
        handlerErroPerdaSessao()
    } else if (error.response.status === 403) {
        handlerErro403();
    }  else if (error.response.status === 404) {
        handlerErro404(error);
    } else {
        handlerErroDefault()
    }

    return Promise.reject(error)
}

function possuiConexaoComInternet(error) {
    return error.response
}

function handlerErroSemConexaoInternet() {
    store.commit(mutationTypes.MOSTRAR_MENSAGEM_ERRO, notificacoesDefault.ERRO_SEM_CONEXAO_INTERNET)
}

function handlerErro403() {
    store.commit(mutationTypes.MOSTRAR_MENSAGEM_SEM_PERMISSAO_ACESSO)
}

function handlerErro404(error) {
    handlerErro500(error)
    const deveIgnorarRedirect = error && error.config && error.config.ignorarRedirecionamento404
    if (!deveIgnorarRedirect) {
        redirecionarParaHome()
    }
}

function handlerErro400(error) {
    const ehDomainException = _.get(error, 'response.data.key') !== undefined
    const ehExceptionList = _.get(error, 'response.data.errorMessages.length') !== undefined
    const ehGenericValidationException = _.get(error, 'response.data.message') !== undefined
    if(ehDomainException) {
        tratarDomainException(error)
    }else if(ehExceptionList){
        tratarExceptionList(error)
    }else if(ehGenericValidationException){
        tratarGenericValidationException(error)
    }else{
        throw error
    }
}

function tratarDomainException(error){
    if(error.response.data.key === 'LICITACAO_EXCLUIDA') {
        mensagemErroComRedirectTimeout(error.response.data.message, 6)
    }else{
        if(error.response.data.message) {
            store.commit(mutationTypes.MOSTRAR_MENSAGEM_ERRO, error.response.data.message)
        }else{
            store.commit(mutationTypes.MOSTRAR_MENSAGEM_ERRO_DEFAULT)
        }
    }
}

function tratarExceptionList(error) {
    if(_.get(error, 'response.data.errorMessages.length') === 1){
        const mensagem = _.get(error, 'response.data.errorMessages[0].message')
        store.commit(mutationTypes.MOSTRAR_MENSAGEM_ERRO, mensagem)
    }else {
        throw error
    }
}

function tratarGenericValidationException(error) {
    if (error.response.data.message) {
        store.commit(mutationTypes.MOSTRAR_MENSAGEM_ERRO, error.response.data.message)
    } else {
        store.commit(mutationTypes.MOSTRAR_MENSAGEM_ERRO_DEFAULT)
    }
}

function mensagemErroComRedirectTimeout(mensagem, tempoEsperaRedirect = 0){
    const mensagemAguarde = mensagem + ' Aguarde, você será redirecionado'
    if(tempoEsperaRedirect > 0){
        store.commit(mutationTypes.MOSTRAR_MENSAGEM_ERRO,
            mensagemAguarde + ` em ${tempoEsperaRedirect}...`)
    }

    setTimeout(() => {
        redirecionarParaHome()
    }, tempoEsperaRedirect * 1000)

    let timeleft = tempoEsperaRedirect-1
    let redirectTimer = setInterval(() => {
        if(timeleft >= 1){
            store.commit(mutationTypes.MOSTRAR_MENSAGEM_ERRO,
                mensagemAguarde + ` em ${timeleft}...`)
        }else{
            store.commit(mutationTypes.MOSTRAR_MENSAGEM_ERRO,
                mensagem + ' Você foi redirecionado.')
            clearInterval(redirectTimer)
        }
        timeleft -= 1
    }, 1000)
}

function handlerErro500(error) {
    let mensagem = null
    if(error.response.data.exception && exceptions[error.response.data.exception]) {
        const exception = exceptions[error.response.data.exception]
        if (exception && exception.ignorarNotificacaoDefault){
            return
        }
        mensagem = formatarMensagemExcecao(exception, error.response.data.message)
    }else{
        mensagem = error.response.data.message
    }

    if (mensagem) {
        store.commit(mutationTypes.MOSTRAR_MENSAGEM_ERRO, mensagem)
    } else {
        store.commit(mutationTypes.MOSTRAR_MENSAGEM_ERRO_DEFAULT)
    }
}

function formatarMensagemExcecao(exception, params) {
    if (!exception) {
        return undefined
    }
    if (params) {
        const parsedParams = JSON.parse(params)
        return exception.mensagem.replace(/{(\d+)}/g, function (match, number) {
            return typeof parsedParams[number] !== 'undefined' ? parsedParams[number] : match
        })
    }
    return exception.mensagem
}


function handlerErroPerdaSessao() {
    store.commit(mutationTypes.MOSTRAR_MENSAGEM_ERRO_PERDA_SESSAO)
    setTimeout(() => window.location.reload(), 3000)
}

function handlerErroDefault() {
    store.commit(mutationTypes.MOSTRAR_MENSAGEM_ERRO_DEFAULT)
}

function redirecionarParaHome() {
    router.push({path: '/'})
}

axios.interceptors.request.use(requestSuccessInterceptor, errorHandlerInterceptor)
axios.interceptors.response.use(responseSuccessInterceptor, errorHandlerInterceptor)
//marca todas as requisicoes ajax
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
